import { TextMessageRecord } from "./text-message-record";

export class TextMessageModel extends TextMessageRecord {
  message: string;

  constructor(data: Partial<TextMessageModel> = {}) {
    super(data);
    this.message = data.message ?? '';
  }
}
